import * as noUiSlider from "nouislider";
window.noUiSlider = noUiSlider;
// CSS importato da app.scss
import '/node_modules/nouislider/dist/nouislider.min.css';